<template>
  <div v-show="rating !== null">
    <img
      v-for="(value, index) of stars"
      :key="index"
      :src="value"
      :class="starClass"
    >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    rating: {
      type: Number,
      required: false,
      default: null,
    },

    starClass: {
      type: String,
      required: false,
      default: '',
    },

    halfStar: {
      type: String,
      required: true,
    },

    fullStar: {
      type: String,
      required: true,
    },
  },

  data () {
    const stars = [];
    const rating = this.rating / 2;

    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(this.fullStar);
      } else {
        stars.push(this.halfStar);
      }
    }

    return {
      stars,
    };
  },
};
</script>
